<template>
    <div class="clear-token-page">
      <h2>获取登录信息</h2>
      <p>正在获取浏览器中的登录信息...</p>
    </div>
  </template>
  
  <script>
  import { encryptUserInfo } from '@/utils/ssoEncryptor';
  export default {
    name: 'CheckToken',
    data() {
      return {
        unionid: ''
      }
    },
    mounted() {
      this.unionid = this.$route.query.unionid;
      this.checkToken();
    },
    methods: {
      checkToken() {
        const encrypted = encryptUserInfo(this.unionid);
        this.$http({
          url: "/api/v1/cx/uniqueLogin",
          method: "POST",
          data: {
            unique: encrypted
          }
        }).then((res) => {
          if (res.code == 200) {
            localStorage.setItem('token', res.data);
          }
        })
      }
    }
}
</script>
  
  <style scoped>
  .clear-token-page {
    text-align: center;
    padding: 50px;
  }
  </style>